import ContactForm from "../../contact/ContactForm";
import PublicNavbar from "../components/PublicNavbar";

import "./contact-page.css";

export default function ContactPage() {
  return (
    <div className="sl-contact-page">
      <PublicNavbar />

      <main className="sl-contact-main">
        <ContactForm />
      </main>
    </div>
  );
}
